<template>
	<div style="width:800px; height:610px;" v-on:keyup.esc="close()">
		<div class="view_inner">
			<div style="height: 530px; overflow-y: auto; overflow-x: hidden;">
				<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable border="0">
					<thead>
						<tr>
							<th style="text-align:center;width:130px;">CRT Datetime</th>
							<th style="text-align:center;width:90px;">Type</th>
							<th style="text-align:center;width:70px;">Quantity</th>
							<th style="text-align:center;">Details</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="h in history" v-bind:key="h.item_repack_history_no">
							<td>{{ h.crt_dt_local }}</td>
							<td>{{ h.repack_type_name }}</td>
							<td class="al_right">{{ h.quantity }}</td>
							<td>
								<pre>{{ h.details }}</pre>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<br />

			<div class="view_bottom_bt">
				<a href="javascript:;" id="save" type="button" class="gray_bt" @click="close()">Close</a>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/table_box.css';
import { apiSelectRepackHistoryList } from '@/api/item/inventory.js';

export default {
	data: function() {
		return {
			history: [],
		};
	},
	props: {
		item_id: String,
	},
	components: {},
	methods: {
		async selectHistory() {
			const { data } = await apiSelectRepackHistoryList({
				paging_yn: 'N',
				item_id: this.item_id,
			});
			this.history = data.historyList;
		},
		async init() {
			await this.selectHistory();
		},

		close() {
			this.$emit('close');
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
